<template>
  <!-- Header Page -->
  <v-container>
    <v-row align="end">
      <v-col>
        <div class="page-title" :title="titleText">
          <!-- fal fa-hand-holding-usd -->
          <v-icon class="mr-3 gray">{{ titleIcon }}</v-icon>
          <h1 class="primary--text">{{ titleText }}</h1>
        </div>
      </v-col>
      <v-col class="flex-grow-0" v-if="button">
        <v-btn
          ref="headerButton"
          color="secondary"
          rounded
          large
          depressed
          class="px-11"
          @click="button.click"
        >
          <!-- $router.push({ name: routes.web.NewDonations }) -->
          <!-- fal fa-hand-holding-usd -->
          <v-icon class="mr-3" color="white" small v-if="button.icon">{{
            button.icon
          }}</v-icon>
          {{ button.text }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    titleText: {
      type: String,
      default: "Título da pagina",
      required: true
    },
    titleIcon: {
      type: String,
      default: "fal fa-window-maximize"
    },
    button: {
      default: false,
      text: String,
      icon: String,
      click: Function
    }
  },
  methods: {
    getButton() {
        return this.$refs.headerButton;
    }
  }
};
</script>